(function () {
  function initSplide(root) {
    if (!root) return;
    if (root.dataset.gbInit === "true") return;

    var el = root.querySelector(".splide");
    if (!el) return;

    if (typeof Splide === "undefined") return;

    var perPage = parseInt(root.dataset.perPage || "1", 10);

    new Splide(el, {
      type: "loop",
      perPage: perPage,
      gap: "12px",
      pagination: true,
      arrows: false,
      drag: true,
      breakpoints: {
        989: { perPage: 1 }
      }
    }).mount();

    root.dataset.gbInit = "true";
  }

  function initAll() {
    document.querySelectorAll("[data-gb-reviews]").forEach(initSplide);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", function (e) {
    initSplide(e.target);
  });
})();